export default {
  companyName: (state) => (id) => id in state.companies ? state.companies[id].name : id,
  companiesList: (state) => Object.values(state.companies)
}
